import React from 'react';

interface IIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

export const CarouselNext = ({ fill = 'white', width = 12, height = 12 }: IIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_1008_12301)">
            <g clipPath="url(#clip1_1008_12301)">
                <path
                    d="M4.45215 0.946668L11.0381 7.53267C11.16 7.65934 11.228 7.82826 11.228 8.004C11.228 8.17974 11.16 8.34866 11.0381 8.47533L4.45548 15.0573L5.39815 16L11.9808 9.418C12.3442 9.03677 12.5468 8.53032 12.5468 8.00367C12.5468 7.47702 12.3442 6.97057 11.9808 6.58933L5.39482 0.00400174L4.45215 0.946668Z"
                    fill={fill}
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1008_12301">
                <rect
                    width="16"
                    height="16"
                    fill={fill}
                    transform="translate(16.4995) rotate(90)"
                />
            </clipPath>
            <clipPath id="clip1_1008_12301">
                <rect
                    width="16"
                    height="16"
                    fill={fill}
                    transform="translate(16.4995) rotate(90)"
                />
            </clipPath>
        </defs>
    </svg>
);
